import { render } from "./MiChip.vue?vue&type=template&id=583abd5e&scoped=true"
import script from "./MiChip.vue?vue&type=script&lang=js"
export * from "./MiChip.vue?vue&type=script&lang=js"

import "./MiChip.vue?vue&type=style&index=0&id=583abd5e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583abd5e"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
